import { render, staticRenderFns } from "./AICall.vue?vue&type=template&id=99949574"
import script from "./AICall.vue?vue&type=script&lang=js"
export * from "./AICall.vue?vue&type=script&lang=js"
import style0 from "./AICall.vue?vue&type=style&index=0&id=99949574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports